/*
 *   This is a service for a specific store module which uses the api.ts Axios instance as a base.
 *   We separate our files for easy managment and readibility.
 *   We export this as a service to be used in other areas of the application.
 */

import Api from '@/services/api';

export default { 

  listAll() {
    return Api(true).get('/driver/checklist/list_all');
  },

  listActions() {
    return Api(true).get('/driver/checklist/list_actions');
  },

  create(params: {
    name: string,
  }) {
    return Api(true).post('/driver/checklist/create', params);
  },

  done(params: {
    checklistId: number,
    driverId: number,
  }) {
    return Api(true).post('/driver/checklist/action', params);
  },

}